/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/js/components/tabs.js
  var _TabsComponent = class _TabsComponent extends HTMLElement {
    constructor() {
      super();
      this._onTabClick = this._onTabClick.bind(this);
      this._tabs = [];
      this._panels = [];
    }
    connectedCallback() {
      var _a;
      this._tabs = Array.from(this.querySelectorAll(".tab"));
      this._panels = Array.from(this.querySelectorAll(".tabPanel"));
      this._tabs.forEach((tab, index) => {
        tab.dataset.index = String(index);
        tab.addEventListener("click", this._onTabClick);
        tab.setAttribute("role", "tab");
        tab.setAttribute("tabindex", tab.classList.contains("active") ? "0" : "-1");
      });
      this.setAttribute("role", "tablist");
      this._panels.forEach((panel, i) => {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("aria-hidden", "true");
        panel.style.display = "none";
      });
      if (this._tabs.length && this._panels.length) {
        const initialIndex = Math.max(0, Math.min(
          Number((_a = this.getAttribute("initial-index")) != null ? _a : 0),
          this._tabs.length - 1
        ));
        this._activate(initialIndex);
      }
    }
    disconnectedCallback() {
      this._tabs.forEach((tab) => tab.removeEventListener("click", this._onTabClick));
    }
    _onTabClick(e) {
      const index = Number(e.currentTarget.dataset.index);
      this._activate(index);
    }
    _activate(index) {
      this._tabs.forEach((t, i) => {
        t.classList.toggle("active", i === index);
        t.setAttribute("aria-selected", i === index ? "true" : "false");
        t.setAttribute("tabindex", i === index ? "0" : "-1");
      });
      this._panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.style.display = isActive ? "" : "none";
        panel.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    }
  };
  __name(_TabsComponent, "TabsComponent");
  var TabsComponent = _TabsComponent;
  var tabs = /* @__PURE__ */ (() => {
    function init() {
      if (!customElements.get("tabs-component")) {
        customElements.define("tabs-component", TabsComponent);
      }
    }
    __name(init, "init");
    return { init };
  })();
  var tabs_default = tabs;

  // src/js/sections/store-locator.js
  var mainStoreLocator = /* @__PURE__ */ function() {
    let map;
    let currentInfoWindow = null;
    const markers = [];
    const elementToMarker = /* @__PURE__ */ new WeakMap();
    const DEFAULT_CENTER = { lat: 53, lng: -8 };
    const INITIAL_ZOOM = 4;
    const SEARCH_ZOOM = 15;
    let initialBoundsLatLng = null;
    function getStoreTitleText(titleEl) {
      if (!titleEl) return "";
      return Array.from(titleEl.childNodes).filter((n) => n.nodeType === Node.TEXT_NODE).map((n) => n.textContent.trim()).join("");
    }
    __name(getStoreTitleText, "getStoreTitleText");
    function buildInfoWindowContent(titleHTML, addressHTML, hoursHTML) {
      return `
      <div class="store-infowindow">
        <h4 class="store-infowindow__title">${titleHTML || ""}</h4>
        <div class="store-infowindow__body">
          ${addressHTML ? `<p>${addressHTML}</p>` : ""}
          ${hoursHTML ? `<p>${hoursHTML}</p>` : ""}
        </div>
      </div>`;
    }
    __name(buildInfoWindowContent, "buildInfoWindowContent");
    function showAllStores() {
      document.querySelectorAll(".store-locator__store").forEach((store) => {
        store.style.display = "";
      });
    }
    __name(showAllStores, "showAllStores");
    function restoreInitialMapView() {
      if (initialBoundsLatLng) {
        const b = new google.maps.LatLngBounds(
          initialBoundsLatLng.sw,
          initialBoundsLatLng.ne
        );
        map.fitBounds(b);
      } else {
        map.setCenter(DEFAULT_CENTER);
        map.setZoom(INITIAL_ZOOM);
      }
    }
    __name(restoreInitialMapView, "restoreInitialMapView");
    function normalizeTextForSearch(str) {
      const upper = String(str || "").toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();
      const upperNoSpace = upper.replace(/\s/g, "");
      const alnum = upper.replace(/[^A-Z0-9]/g, "");
      const alnumZeroO = alnum.replace(/O/g, "0");
      return {
        upperSpaced: upper,
        upperNoSpace,
        alnum,
        alnumZeroO
      };
    }
    __name(normalizeTextForSearch, "normalizeTextForSearch");
    function doesRecordMatchQuery(normalizedRecord, normalizedQuery) {
      if (!normalizedQuery.upperSpaced) return true;
      return normalizedRecord.upperSpaced.includes(normalizedQuery.upperSpaced) || normalizedRecord.upperNoSpace.includes(normalizedQuery.upperNoSpace) || normalizedRecord.alnum.includes(normalizedQuery.alnum) || normalizedRecord.alnumZeroO.includes(normalizedQuery.alnumZeroO);
    }
    __name(doesRecordMatchQuery, "doesRecordMatchQuery");
    function runSearch(query) {
      const normalizedQuery = normalizeTextForSearch(query);
      if (!normalizedQuery.upperSpaced) {
        showAllStores();
        restoreInitialMapView();
        return;
      }
      const matchedMarkers = [];
      document.querySelectorAll(".store-locator__store").forEach((storeEl) => {
        const titleEl = storeEl.querySelector(".store__title");
        const addressEl = storeEl.querySelector(".store__address");
        const titleText = getStoreTitleText(titleEl);
        const addressText = addressEl ? addressEl.textContent || "" : "";
        const normalizedRecord = normalizeTextForSearch(`${addressText} ${titleText}`);
        const isMatch = doesRecordMatchQuery(normalizedRecord, normalizedQuery);
        storeEl.style.display = isMatch ? "" : "none";
        if (isMatch) {
          const markerData = elementToMarker.get(storeEl);
          if (markerData) matchedMarkers.push(markerData);
        }
      });
      if (matchedMarkers.length === 1) {
        const { lat, lng } = matchedMarkers[0];
        map.setCenter({ lat, lng });
        map.setZoom(SEARCH_ZOOM);
      } else if (matchedMarkers.length > 1) {
        const b = new google.maps.LatLngBounds();
        matchedMarkers.forEach((m) => b.extend({ lat: m.lat, lng: m.lng }));
        map.fitBounds(b);
      }
    }
    __name(runSearch, "runSearch");
    function initMap() {
      return __async(this, null, function* () {
        var _a;
        const mapEl = document.getElementById("store-locator-map");
        const mapId = "WEAVERS_STORE_LOCATOR";
        if (!mapEl) return;
        const { Map } = yield google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = yield google.maps.importLibrary("marker");
        map = new Map(mapEl, { zoom: INITIAL_ZOOM, center: DEFAULT_CENTER, mapId });
        const storeElements = document.querySelectorAll(".store-locator__store");
        if (!storeElements.length) return;
        const bounds = new google.maps.LatLngBounds();
        const pinUrl = (_a = document.querySelector(".store-locator")) == null ? void 0 : _a.dataset.pin;
        storeElements.forEach((storeEl) => {
          var _a2, _b;
          const lat = parseFloat(storeEl.dataset.lat);
          const lng = parseFloat(storeEl.dataset.lng);
          if (Number.isNaN(lat) || Number.isNaN(lng)) return;
          const titleEl = storeEl.querySelector(".store__title");
          const titleHTML = (titleEl == null ? void 0 : titleEl.innerHTML) || "";
          const storeName = getStoreTitleText(titleEl);
          const addressHTML = ((_a2 = storeEl.querySelector(".store__address")) == null ? void 0 : _a2.innerHTML) || "";
          const hoursHTML = ((_b = storeEl.querySelector(".store__working-hours")) == null ? void 0 : _b.innerHTML) || "";
          const infoContent = buildInfoWindowContent(titleHTML, addressHTML, hoursHTML);
          const infoWindow = new google.maps.InfoWindow({
            content: infoContent,
            maxWidth: 240,
            ariaLabel: storeName
          });
          infoWindow.addListener("closeclick", () => {
            showAllStores();
            restoreInitialMapView();
          });
          let markerData;
          if (pinUrl) {
            const customPin = document.createElement("img");
            customPin.src = pinUrl;
            const marker = new AdvancedMarkerElement({
              position: { lat, lng },
              map,
              content: customPin,
              title: storeName
            });
            marker.addListener("click", () => {
              if (currentInfoWindow) currentInfoWindow.close();
              infoWindow.open({ anchor: marker, map });
              currentInfoWindow = infoWindow;
              runSearch(storeName);
            });
            markerData = { marker, infoWindow, el: storeEl, name: storeName, lat, lng };
          } else {
            const marker = new google.maps.Marker({
              position: { lat, lng },
              map,
              title: storeName
            });
            marker.addListener("click", () => {
              if (currentInfoWindow) currentInfoWindow.close();
              infoWindow.open({ anchor: marker, map });
              currentInfoWindow = infoWindow;
              runSearch(storeName);
            });
            markerData = { marker, infoWindow, el: storeEl, name: storeName, lat, lng };
          }
          markers.push(markerData);
          elementToMarker.set(storeEl, markerData);
          bounds.extend({ lat, lng });
        });
        if (!bounds.isEmpty()) {
          if (storeElements.length > 1) map.fitBounds(bounds);
          else map.setCenter(bounds.getCenter());
        }
        google.maps.event.addListenerOnce(map, "idle", () => {
          if (!bounds.isEmpty()) {
            initialBoundsLatLng = {
              sw: bounds.getSouthWest().toJSON(),
              ne: bounds.getNorthEast().toJSON()
            };
          } else {
            initialBoundsLatLng = null;
          }
        });
      });
    }
    __name(initMap, "initMap");
    function bindSearch() {
      const input = document.getElementById("storeLocatorSearch");
      if (input) {
        input.addEventListener("input", () => runSearch(input.value));
        const form = document.querySelector(".store-locator__search");
        if (form) {
          form.addEventListener("submit", (e) => {
            e.preventDefault();
            runSearch(input.value);
          });
        }
      }
    }
    __name(bindSearch, "bindSearch");
    function init() {
      bindSearch();
      initMap();
    }
    __name(init, "init");
    return { init };
  }();
  var store_locator_default = mainStoreLocator;

  // src/js/components/store-images.js
  var storeImagesSlider = /* @__PURE__ */ function() {
    function init() {
      const sliders = document.querySelectorAll(".store__image-slider");
      if (!sliders.length) return;
      sliders.forEach((slider) => {
        const images = slider.querySelectorAll(".store__image");
        const prevButton = slider.querySelector(".prev");
        const nextButton = slider.querySelector(".next");
        if (!images.length) return;
        let currentIndex = 0;
        function updateSlider() {
          images.forEach((img, index) => {
            img.style.display = index === currentIndex ? "block" : "none";
          });
          if (prevButton) prevButton.disabled = currentIndex === 0;
          if (nextButton) nextButton.disabled = currentIndex === images.length - 1;
        }
        __name(updateSlider, "updateSlider");
        prevButton == null ? void 0 : prevButton.addEventListener("click", () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        });
        nextButton == null ? void 0 : nextButton.addEventListener("click", () => {
          if (currentIndex < images.length - 1) {
            currentIndex++;
            updateSlider();
          }
        });
        updateSlider();
      });
    }
    __name(init, "init");
    return { init };
  }();
  var store_images_default = storeImagesSlider;

  // src/js/index.js
  (function() {
    document.addEventListener("DOMContentLoaded", function() {
      tabs_default.init();
      if (window.location.href.indexOf("/pages/store-locator") > -1) {
        store_locator_default.init();
      }
      if (window.location.href.indexOf("/pages/our-stores") > -1) {
        store_images_default.init();
      }
    });
  })();
})();
